import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09da9420"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-title-warp" }
const _hoisted_2 = { class: "page-title" }


export default /*#__PURE__*/_defineComponent({
  __name: 'title',
  props: {
  title: {
    type: String,
    default: '',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(__props.title) + " ", 1),
      _renderSlot(_ctx.$slots, "title")
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})